import { useAuth } from '../context/AuthContext';
import { Button } from '../components/common/Button';
import { useNavigate } from 'react-router-dom';
import './LocalGame.css'; // Reusing general styles for container

const Settings = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Failed to log out', error);
    }
  };

  return (
    <div className="game-container">
      <div className="game-header">
        <div>Impostazioni</div>
        <Button size="sm" variant="ghost" onClick={() => navigate('/')}>
          Indietro
        </Button>
      </div>

      <div className="game-main" style={{ justifyContent: 'flex-start', paddingTop: '2rem' }}>
        <div
          className="card"
          style={{ padding: '2rem', width: '100%', maxWidth: '400px', textAlign: 'center' }}
        >
          <h2 style={{ marginBottom: '1rem' }}>Profilo Utente</h2>
          <p style={{ marginBottom: '0.5rem' }}>
            <strong>Email:</strong> {currentUser?.email}
          </p>
          <p style={{ marginBottom: '2rem' }}>
            <strong>UID:</strong> {currentUser?.uid}
          </p>

          <Button variant="error" fullWidth onClick={handleLogout}>
            Disconnetti
          </Button>
        </div>

        {/* Legal links — required by both Google Play and Apple App Store */}
        <div
          style={{
            marginTop: '1.75rem',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          <div style={{ display: 'flex', gap: '1.25rem', alignItems: 'center' }}>
            <button
              onClick={() => navigate('/privacy')}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--color-text-muted)',
                fontFamily: 'var(--font-main)',
                fontSize: '0.78rem',
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '3px',
              }}
            >
              Privacy Policy
            </button>
            <span style={{ color: 'var(--color-text-dim)', fontSize: '0.78rem' }}>·</span>
            <button
              onClick={() => navigate('/terms')}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--color-text-muted)',
                fontFamily: 'var(--font-main)',
                fontSize: '0.78rem',
                cursor: 'pointer',
                textDecoration: 'underline',
                textUnderlineOffset: '3px',
              }}
            >
              Termini di Servizio
            </button>
          </div>
          <p
            style={{
              opacity: 0.45,
              fontSize: '0.72rem',
              margin: 0,
              color: 'var(--color-text-dim)',
            }}
          >
            Chain Reaction v1.0.0
          </p>
        </div>
      </div>
    </div>
  );
};

export default Settings;
